import { usingGet } from '@ocean/api'

export const getSimulatorTrainingSchedule = (scheduleId: Guid) =>
  usingGet(`SimulatorTrainings/instructorLed/user/schedules/${scheduleId}`, {
    useProxy: true,
  })
